import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import Page from '@src/components/page';
import Store from './store';
import { MECHA_INFO } from './config';

const MechaUnit = ({ store }) => {
  store.use();

  const mechaComp = MECHA_INFO[store.mechaId]?.component;

  if (mechaComp) {
    return React.createElement(mechaComp, { store: store.mechaStore, onBack: store.back });
  }

  return <Page />;
};

export default wrapStore(MechaUnit, Store);
